export default "__VITE_ASSET__kFzFspcw__"